import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { FlatList } from 'react-native'

export interface RenderTable1ItemProps {
  item: RowItem
  borderWidth: number
  borderColor: ColorOptions
  index: number
  isLastItem: boolean
}

export const RenderTable1Item = ({ item, borderWidth, borderColor, isLastItem }: RenderTable1ItemProps) => {
  if (item === undefined) {
    return null
  }
  return (
    <Box
      flexDirection={'row'}
      borderColor={borderColor}
      borderTopWidth={borderWidth}
      borderBottomWidth={isLastItem ? borderWidth : 0}
      borderLeftWidth={borderWidth}
      borderRightWidth={borderWidth}>
      {item?.values?.map(({ text, containerStyle, textStyle }: any, index: any) => {
        return (
          <Box
            {...(containerStyle ? containerStyle : styles.tableItem(item?.id))}
            borderRightWidth={index !== item?.values?.length - 1 ? borderWidth : 0}
            borderColor={borderColor}>
            <Text {...(textStyle ?? {})}>
              <Text title={text} fontFamily={item.id !== '0' ? 'jiotype-medium' : 'jiotype-bold'} />
            </Text>
          </Box>
        )
      })}
    </Box>
  )
}

interface RenderCustomItemProps {
  item: CustomTableItemProps
  borderWidth: number
  borderColor: ColorOptions
  headerBG: ColorOptions
}

export const RenderCustomItem = ({ item, borderWidth, borderColor, headerBG }: RenderCustomItemProps) => {
  return (
    <Box flexDirection={'row'}>
      {item.docType && (
        <Box
          bg={item.id === '0' ? headerBG : 'TRANSPARENT'}
          w={150}
          justify={item.id === '0' ? 'center' : 'flex-start'}
          borderTopWidth={borderWidth}
          borderLeftWidth={borderWidth}
          borderBottomWidth={borderWidth}
          borderColor={borderColor}
          ph={8}
          pv={4}>
          <Text title={item.docType} textAlign={'center'} fontFamily={'jiotype-bold'} />
        </Box>
      )}
      {item?.data && (
        <Box f={1}>
          <Table data={item.data} borderWidth={borderWidth} borderColor={borderColor} />
        </Box>
      )}
    </Box>
  )
}

export interface TableItemProps {
  text: string
  containerStyle?: BoxProps
  textStyle?: TextProps
}

export interface RowItem {
  id: string
  values: TableItemProps[]
}
export interface TableProps {
  data: RowItem[]
  borderWidth?: number
  contentState?: any
  entityKey?: string
  borderColor?: ColorOptions | Array<ColorOptions>
}

export const Table = ({ data, borderWidth = 1, contentState, entityKey, borderColor }: TableProps) => {
  const key = entityKey
  const { tableData } = contentState?.getEntity(key)?.getData() ?? {}
  const actualData = tableData ? tableData : data
  return (
    <Box borderWidth={0} borderColor={borderColor}>
      <FlatList
        data={actualData}
        renderItem={({ item, index }) => (
          <RenderTable1Item
            item={item}
            borderWidth={borderWidth}
            borderColor={borderColor}
            isLastItem={index === actualData?.length - 1}
          />
        )}
      />
    </Box>
  )
}

interface CustomTableItemProps {
  id: string
  data: RowItem[]
  docType: string
}

interface CustomTableProps {
  entityKey?: string
  data: CustomTableItemProps[]
  contentState?: any
  borderColor?: ColorOptions
  headerBG?: ColorOptions
  borderWidth?: number
}
export const CustomTable = ({
  entityKey,
  data,
  contentState,
  borderWidth = 1,
  borderColor = 'SEPERATOR',
  headerBG = 'LIGHT_GREY',
}: CustomTableProps) => {
  const key = entityKey
  const { tableData } = contentState?.getEntity(key)?.getData() ?? {}
  const actualData = tableData ? tableData : data
  return (
    <FlatList
      data={actualData}
      renderItem={({ item }: any) => (
        <RenderCustomItem item={item} borderWidth={borderWidth} borderColor={borderColor} headerBG={headerBG} />
      )}
    />
  )
}

const styles = {
  tableItem: (id: any) =>
    ({
      f: 1,
      justify: 'center',
      align: id === '0' ? 'center' : 'flex-start',
      p: 8,
      bg: id === '0' ? 'GRAY_LIGHT' : 'WHITE',
    } as BoxProps),
}
